import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { OrderingProcessService } from '../../services/ordering-process/ordering-process.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements OnInit {
  constructor(
    private readonly router: Router,
    private readonly activatedRoute: ActivatedRoute,
    private readonly orderingProcessService: OrderingProcessService
  ) {}

  ngOnInit(): void {}

  next(): void {
    this.orderingProcessService
      .getCurrentStep()
      .submit()
      .subscribe((canContinue) => {
        if (canContinue) {
          this.navigateTo(this.orderingProcessService.getNextRoute());
        }
      });
  }

  private navigateTo(route: string): void {
    this.activatedRoute.paramMap.subscribe((paramMap: ParamMap) => {
      this.router.navigate([paramMap.get('language'), route]);
    });
  }

  previous(): void {
    this.navigateTo(this.orderingProcessService.getPreviousRoute());
  }

  canGoBack(): boolean {
    return this.orderingProcessService.canGoBack();
  }

  canGoNext(): boolean {
    return this.orderingProcessService.canGoNext();
  }

  isFinalStep(): boolean {
    return this.orderingProcessService.isFinalStep();
  }
}
